import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class TransferActionDTO {
  @ApiProperty()
  @IsNotEmpty({message:"Transfer Action id should not be empty"})
  @IsAlphanumeric()
  transferActionId: number;

  @ApiProperty()
  @IsDate()
  transferDate: any;

  @ApiProperty()
  @IsNotEmpty()
   employeeCode: string;

  @ApiProperty()
  @IsNotEmpty()
  employeeName: string;

  @ApiProperty()
  designation:string;

  @ApiProperty()
   employeeRole:string;

  @ApiProperty()
  approvedBy:string;

  @ApiProperty()
   fromPlant:string

  @ApiProperty()
  toPlant:string
 
  @ApiProperty()
  isActive: boolean;

  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;
}

